import { object, string, type InferInput, type InferOutput } from "valibot";

const createGuestAccountParamsSchema = object({
  email: string(),
  returnContext: string(),
});

const createGuestAccountResultSchema = object({
  user: object({
    id: string(),
    email: string(),
    name: string(),
  }),
  authToken: string(),
  sessionToken: string(),
});

export type CreateGuestAccountParams = InferInput<typeof createGuestAccountParamsSchema>;
export type CreateGuestAccountResult = InferOutput<typeof createGuestAccountResultSchema>;

export const createGuestAccountRpcContract = {
  name: "create-guest-account" as const,
  paramsSchema: createGuestAccountParamsSchema,
  resultSchema: createGuestAccountResultSchema,
};
